import React from 'react';
import { WrapperItem } from '../../components/wrapper-item';
import { Section } from '../../components/section';
import { Column } from '../../components/column';
import { shorthand } from '../../utils/css-utils';
import { BdiWrapper } from '../../components/bdi-wrapper';
import { Button } from './button';
export class SectionButton extends React.Component {
    render() {
        const { section, cssClass, isRtl, columnCssClass } = this.props;
        const { button, containerBackground, border } = section;
        const direction = isRtl ? 'rtl' : 'ltr';
        return (React.createElement(WrapperItem, null,
            React.createElement(Section, { backgroundColor: section.backgroundColor, borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, cssClass: cssClass, padding: shorthand(section.outerPadding), textAlign: button.align },
                React.createElement(Column, { backgroundColor: containerBackground || undefined, cssClass: columnCssClass, direction: direction, padding: shorthand(section.innerPadding), border: border },
                    React.createElement(Button, { align: "center", ...button, padding: "0", textDecoration: button.textDecoration, fontStyle: button.fontStyle, hasRelAtr: true, minWidth: section.minWidth, maxWidth: section.maxWidth },
                        React.createElement(BdiWrapper, { text: button.text?.trim() ? button.text : '\u00A0' }))))));
    }
}
//# sourceMappingURL=section-button.js.map